import type { TablePaginationProps } from '@mui/material/TablePagination';
import TablePagination from '@mui/material/TablePagination';

const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 20, 50];

export interface CompactTablePaginationProps
  extends Omit<TablePaginationProps, 'component' | 'rowsPerPageOptions' | 'labelRowsPerPage'> {
  rowsPerPageOptions?: TablePaginationProps['rowsPerPageOptions'];
  labelRowsPerPage?: string;
  hideRowsPerPage?: boolean;
}

/**
 * Compact footer pagination for dense back-office tables.
 *
 * Keeps the control line short and visually lightweight so it does not steal
 * vertical space from the table body.
 */
export function CompactTablePagination({
  rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
  labelRowsPerPage = 'Строк на странице:',
  hideRowsPerPage = false,
  sx,
  ...props
}: CompactTablePaginationProps) {
  const effectiveRowsPerPageOptions = hideRowsPerPage ? [] : [...rowsPerPageOptions];

  return (
    <TablePagination
      component="div"
      rowsPerPageOptions={effectiveRowsPerPageOptions}
      labelRowsPerPage={hideRowsPerPage ? '' : labelRowsPerPage}
      sx={{
        width: '100%',
        minHeight: 44,
        '& .MuiTablePagination-toolbar': {
          minHeight: 44,
          px: 0,
          pl: 0,
          pr: 0,
        },
        '& .MuiTablePagination-spacer': {
          flex: 'none',
        },
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
          my: 0,
        },
        ...(hideRowsPerPage
          ? {
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-input': {
                display: 'none',
              },
            }
          : {
              '& .MuiTablePagination-select': {
                py: 0.25,
              },
              '& .MuiTablePagination-input': {
                mr: 1,
              },
            }),
        '& .MuiTablePagination-actions': {
          ml: 1,
        },
        ...sx,
      }}
      {...props}
    />
  );
}
